<script setup lang="ts">
import type { ComponentStyles } from 'types/index';
import type { QuoteBlockContent } from 'types/blocks';

defineProps<{
  data: QuoteBlockContent;
  componentStyles: ComponentStyles;
}>();
</script>

<template>
  <BaseComponentWrapper
    v-if="data"
    :component-styles="componentStyles"
  >
    <article class="relative">
      <BaseScrollTransition
        class="absolute size-full overflow-hidden"
        content-class="size-full"
        :variables="{ duration: '1.5s' }"
      >
        <figure
          v-if="data.image && data.image.url"
          class="size-full"
        >
          <BaseImage
            class="size-full object-cover"
            :image="data.image"
            :is-decorative="true"
            :style="
              data.imageBrightness !== undefined && data.imageBrightness !== 0
                ? `filter:brightness(${data.imageBrightness / 100});`
                : ''
            "
            sizes="100vw lg:100vw"
          />
        </figure>
      </BaseScrollTransition>

      <div
        v-if="data.quoteText"
        class="container relative py-10 lg:py-40"
      >
        <div class="text-center text-white">
          <BaseScrollTransition>
            <p
              v-if="data.quoteText"
              class="quote-content lg:text-2xl mx-auto max-w-[100ch] text-lg italic lg:pb-6"
            >
              {{ data.quoteText }}
            </p>

            <p
              v-if="data.quotePerson"
              class="text-quote-grey text-right opacity-80"
            >
              {{ data.quotePerson }}
            </p>
          </BaseScrollTransition>
        </div>
      </div>
    </article>
  </BaseComponentWrapper>
</template>
